var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconSpreadSheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 45.145 45.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22628",
    "data-name": "Path 22628",
    d: "M42.506,4H15.95a1.328,1.328,0,0,0-.94.39L4.388,15.013A1.328,1.328,0,0,0,4,15.95V42.506a6.639,6.639,0,0,0,6.639,6.639H42.506a6.639,6.639,0,0,0,6.639-6.639V10.639A6.639,6.639,0,0,0,42.506,4ZM10.639,17.278a6.639,6.639,0,0,0,6.639-6.639V6.656h2.656V19.933H6.656V17.278ZM8.533,14.622l6.089-6.089v2.106a3.983,3.983,0,0,1-3.983,3.983ZM6.656,22.589H19.933V33.211H6.656Zm15.933,0h23.9V33.211h-23.9Zm23.9-11.95v9.294h-23.9V6.656H42.506A3.983,3.983,0,0,1,46.489,10.639ZM6.656,42.506V35.867H19.933V46.489H10.639A3.983,3.983,0,0,1,6.656,42.506Zm35.85,3.983H22.589V35.867h23.9v6.639A3.983,3.983,0,0,1,42.506,46.489Z",
    transform: "translate(-4 -4)",
    fill: "#9797bd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconSpreadSheets);
export default __webpack_public_path__ + "static/media/TabIconSpreadSheets.aa6e58a95b10711b30e5be4bb77f39b0.svg";
export { ForwardRef as ReactComponent };